import React from 'react';
import { Radio } from 'antd';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from './constants/style.constant';
import './styles.scss';

export default function CustomRadio(props) {
	const country = props.country || Enviroment.LANGUAGE;
	return (
			<Radio {...props} className={Dictionary[country][props.className]}>
				
            </Radio>
	)
}